export function categoryBranchIds(categories, selectedId) {
  if (!selectedId) return null;
  const ids = new Set([String(selectedId)]);
  let changed = true;
  while (changed) {
    changed = false;
    for (const category of categories) {
      if (ids.has(String(category.parent_id)) && !ids.has(String(category.id))) {
        ids.add(String(category.id));
        changed = true;
      }
    }
  }
  return ids;
}

export function matchesOrderItems(order, query, categoryIds, products) {
  const term = query.trim().toLowerCase();
  const productMap = new Map(products.map(product => [String(product.id), product]));
  return (order.items || []).some(item => {
    const product = productMap.get(String(item.product_id || item.id));
    const categoryId = item.category_id ?? product?.category_id;
    const text = [item.product_name, item.name, item.sku, product?.name, product?.sku]
      .filter(Boolean).join(' ').toLowerCase();
    return (!term || text.includes(term)) && (!categoryIds || categoryIds.has(String(categoryId)));
  });
}

// The current API does not support order-item/category filters. Collect every
// server page before filtering, then paginate the matches rather than hiding
// matches on other pages. Never submit unsupported filter parameters.
export async function fetchFilteredOrders(api, params, predicate, pageSize) {
  const first = await api.getAll({ ...params, page: 1 });
  const all = [...(first.data.orders || [])];
  for (let page = 2; page <= (first.data.pages || 1); page += 1) {
    const response = await api.getAll({ ...params, page });
    all.push(...(response.data.orders || []));
  }
  const matches = all.filter(predicate);
  const pages = Math.max(1, Math.ceil(matches.length / pageSize));
  const page = Math.min(params.page || 1, pages);
  return { ...first.data, orders: matches.slice((page - 1) * pageSize, page * pageSize), pages, total: matches.length };
}
